import React from 'react';
import { Link } from 'react-router-dom';

import './BottomNav.scss';

const BottomNav = props => {
  return (
    <div className="col-md-12 Bottombg centerList">
      <nav className="navbar navbar-default  topnav">
        <div className="container topnav  text-center">
          <ul className="nav navbar-nav navbar-bottom-right ">
            <li className="copyright"> © 2024</li>
            <li>
              <Link to="/dataprotection">Datenschutzbestimmungen</Link>
            </li>
            <li>
              <Link to="/Impressum">Impressum</Link>
            </li>
            <li>
              <Link to="/contact">Kontakt</Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};
export default BottomNav;



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/BottomNav.js